<template>
   <div id="containt">
  <!-- 服务商 -->
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          <!-- {{ dataId ? '查看' : '新增' }}网点 -->
          我的信息
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="snUserSave"
            @click="saveData">保存</el-button>
        </div>
      </div>
      <div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="用户信息" name="first">
            <!-- 基本信息 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first"><b>基础信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        登录账号
                      </th>
                      <td>
                        <el-input disabled type="text" @blur="inspection" autocomplete="off"
                          v-model="formData.userAccount" clearable />
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        网点名称
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.userName" clearable />
                      </td>
                      <th>网点简称</th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.userShortName" clearable />
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        联系方式
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.userMobile" clearable />
                      </td>

                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        网点地址
                      </th>
                      <td>
                        <el-form-item>
                          <template>
                            <el-cascader :props="areaProps" v-model="areaValues" :clearable="true" @change="handleChange"
                              ref="cascader" :options="areaOption">
                            </el-cascader>
                          </template>

                        </el-form-item>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        详细地址
                      </th>
                      <td>
                        <el-input type="text" :maxlength="10" autocomplete="off" v-model="formData.userAddress"
                          clearable />
                      </td>

                      <th>
                        经度/纬度
                      </th>
                      <td>
                        <div>
                          <el-input type="text" autocomplete="off" v-model="formData.longitude" :disabled="true" clearable
                            style="width: 49%!important;" />
                          <el-input type="text" autocomplete="off" v-model="formData.latitude" :disabled="true" clearable
                            style="width: 49%!important;margin-left:2%" />
                        </div>
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        状态
                      </th>
                      <td>
                        <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                          <el-select v-model="formData.stat" :disabled="!isSite">
                            <el-option label="待审核" :value="1" />
                            <el-option label="审核中" :value="2" />
                            <el-option label="审核驳回" :value="3" />
                            <el-option label="已审核" :value="5" />
                            <!-- <el-option label="暂停" :value="91" />
                            <el-option label="暂挂" :value="92" />
                            <el-option label="撤消" :value="98" />
                            <el-option label="黑名单" :value="99" /> -->
                          </el-select>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>

                    </tr>
                    <tr>
                      <th>
                        <!--                      <em class="f-red">*</em>-->
                        创建人
                      </th>
                      <td>{{ formData.createBy }}</td>
                      <th>
                        <!--                      <em class="f-red">*</em>-->
                        创建时间
                      </th>
                      <td>{{ formData.createTime }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>关键信息</b></div>
                <table class="table-detail">
                  <tbody>

                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        性质名称
                      </th>
                      <td>
                        <el-select v-model="formData.snSiteInfoDTO.siteTypeName" @change="selectSiteType" style="width: 165px;">
                          <el-option v-for="item in siteTypeOption" :key="item.id" :label="item.label"
                                     :value="{value:item.id,label:item.label}"/>
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        运营状态
                      </th>
                      <td>
                        <el-select v-model="formData.snSiteInfoDTO.businessStat" :disabled="!isSite" placeholder=" 运营状态">
                          <el-option label="提报" :value="1" />
                          <el-option label="备用" :value="2" />
                          <el-option label="正常" :value="3" />
                          <el-option label="清账" :value="4" />
                          <el-option label="终止" :value="5" />
                          <el-option label="黑名单" :value="9" />

                        </el-select>
                        <!--                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteLevelName" clearable/>-->
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        层级
                      </th>
                      <td>
                        <el-select v-model="formData.snSiteInfoDTO.siteFloorLevel">
                          <el-option label="一级网点" :value="1" />
                          <el-option label="二级网点" :value="2" />
                        </el-select>
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        所属机构名称
                      </th>
                      <td>
                        <el-cascader v-model="orgValue" :options="orgOptions" @change="orgHandleChange"></el-cascader>
                      </td>

                    </tr>
                    <tr>
                      <th>
                        编码
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteCode" clearable />
                      </td>
                      <th>
                        等级
                      </th>
                      <td>
                        <el-select v-model="formData.snSiteInfoDTO.siteLevelId" placeholder="网点等级" @change="levelChange">
                          <el-option v-for="item in siteLevelOption" :key="item.value" :label="item.label"
                            :value="item.value" />
                        </el-select>
                        <!--                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteLevelName" clearable/>-->
                      </td>

                      <th>
                        上级网点
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.parentSiteName"
                          :disabled="formData.snSiteInfoDTO.siteFloorLevel !== 2" clearable :readonly="true">
                          <i slot="suffix" class="el-input__icon el-icon-search"
                            @click="() => { if (formData.snSiteInfoDTO.siteFloorLevel == 2) { showSiteDialog = true } }"></i>
                        </el-input>
                      </td>
                      <th>
                        代理结算网点
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.settleSiteName" clearable
                          :readonly="true">
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="showProxySiteDialog = true"></i>
                        </el-input>
                        <!--                      <el-input type="text" autocomplete="off"  clearable/>-->
                      </td>
                    </tr>
                    <tr>

                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- 财务信息 -->
              <div class="d-item">
                <div class="title first"><b>财务信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <!-- <th>
                      网点公司名称
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteCompanyName"
                                clearable/>
                    </td> -->
                      <th>
                        税号
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteTaxNo" clearable />
                      </td>
                      <th>税率</th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteInvoiceRate"
                          clearable />
                      </td>

                      <th>
                        发票类型
                      </th>
                      <td>
                        <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                          <el-select v-model="formData.snSiteInfoDTO.siteInvoiceType">
                            <el-option label="无发票" :value="0" />
                            <el-option label="增值税普通发票" :value="1" />
                            <el-option label="增值税专用发票" :value="2" />
                          </el-select>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        银行名称
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.bankName" clearable />
                      </td>
                      <th>
                        银行帐号
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.bankAccount" clearable />
                      </td>

                      <th>
                        银行帐户
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.bankAccountName"
                          clearable />
                      </td>

                    </tr>
                    <tr>
                      <th>
                        法人单位
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.legalPersonCompany"
                          clearable />
                      </td>
                      <th>
                        法人代表
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.legalPerson" clearable />
                      </td>

                      <th>
                        法人联系方式
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.legalPersonMobile"
                          clearable />
                      </td>

                    </tr>
                  </tbody>
                </table>

              </div>
              <!-- 人员信息 -->
              <div class="d-item">
                <div class="title first"><b>人员信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        联系人
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteMan" clearable />
                      </td>
                      <th>
                        联系人电话
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteManMobile"
                          clearable />
                      </td>
                      <th>信息员或联系方式</th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteOrderMan"
                          clearable />
                      </td>
                      <th>
                        财务员或联系方式
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteFinMan" clearable />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        配件员或联系方式
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.sitePartsMan"
                          clearable />
                      </td>
                      <th>
                        工程师负责人或联系方式
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteEngineerMan"
                          clearable />
                      </td>
                      <th>
                        技术负责人或联系方式
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteTechMan" clearable />
                      </td>
                    <tr>
                      <th>网点介绍</th>
                      <td colspan="5">
                        <el-input class="annotate" type="textarea" :rows="1" placeholder="请输入内容" size="small"
                          v-model="formData.snSiteInfoDTO.siteDescription" clearable></el-input>
                      </td>
                    </tr>
                    </tr>

                  </tbody>

                </table>
                <!-- 人员信息 -->


                <vxe-table :stripe="true" style="margin-top: 10px;"
                  :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                  :header-row-style="{ height: '36px' }" :row-style="{ fontSize: '12px', background: '#fff' }"
                  show-overflow keep-source :row-config="{ height: 36 }" ref="xTable" height="150"
                  :column-config="{ resizable: true }" :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                  :data="formData.basSiteManList">
                  <vxe-column field="custMobile" title="人员账号" width="150" />
                  <vxe-column field="custPhone1" title="人员名称" width="110" />
                  <vxe-column field="custPhone2" title="岗位" width="110" />
                </vxe-table>
              </div>
              <!-- 地址信息 -->
              <div class="d-item" style="margin-bottom: 50px;">
                <div class="title first">
                  <b>地址信息</b>
                  <el-button type="primary" class="button-sty btn_zdy" @click="showAreaDialog = true; areaObj = null">
                    <i class="el-icon-plus"></i>
                    新增地址
                  </el-button>
                </div>
                <vxe-table :stripe="true" v-if="showAddressListTable"
                  :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                  :header-row-style="{ height: '36px' }" :row-style="{ fontSize: '12px', background: '#fff' }"
                  show-overflow keep-source :row-config="{ height: 36 }" ref="xTable" height="150"
                  :column-config="{ resizable: true }" :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                  :data="formData.basCustAddressList">
                  <vxe-column field="addressTypeName" title="地址类型" width="110" />
                  <vxe-column field="addressMan" title="联系人姓名" width="110" />
                  <vxe-column field="addressMobile" title="联系人电话" width="110" />
                  <vxe-column title="地址" width="180">
                    <template #default="{ row }">
                      <span>{{ row.province }}{{ row.city }}{{ row.county }}{{ row.town }}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="address" title="详细地址" width="180" />
                  <!-- <vxe-column field="isDefault" title="是否默认地址" width="100">
                  <template #default="{ row }">
                    <span v-if="row.isDefault==1">是</span>
                    <span v-if="row.isDefault==0">否</span>
                  </template>
                </vxe-column> -->
                  <vxe-column title="操作" width="120">
                    <template #default="{ row }">
                      <a href="javascript:void(0);" class="a-link" @click="editArea(row)">
                        <el-tooltip effect="dark" content="编辑" placement="top" popper-class="tooltip-skin">
                          <i class="el-icon-edit" />
                        </el-tooltip>
                      </a>
                      &nbsp;
                      &nbsp;
                      <a class="a-link" href="javascript:void(0);" @click="deleteArea(row)">
                        <el-tooltip content="删除" effect="dark" placement="top" popper-class="tooltip-skin">
                          <i class="el-icon-delete" />
                        </el-tooltip>
                      </a>
                    </template>
                  </vxe-column>
                </vxe-table>


              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="信息认证" name="second">
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first"><b>业务设置</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        接收短信手机1
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteMessagePhone1"
                          clearable />
                      </td>
                      <th>
                        接收短信手机2
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteMessagePhone2"
                          clearable />
                      </td>
                      <th>远程费计算起点</th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteDistanceBasAddress"
                          clearable />
                      </td>
                      <th>
                        第三方接口appsecret
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.thirdRequestAppsecret"
                          clearable />
                      </td>

                    </tr>
                    <tr>
                      <th>
                        远程费基数
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteDisBas" clearable />
                      </td>
                      <th>
                        远程费费率
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteDisRate" clearable />
                      </td>

                      <th>
                        封顶远程费
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.siteTopDis" clearable />
                      </td>

                      <th>
                        是否全国性网点
                      </th>
                      <td>
                        <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                          <el-select v-model="formData.snSiteInfoDTO.siteOverAllArea">
                            <el-option label="否" :value="0" />
                            <el-option label="是" :value="1" />
                          </el-select>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        计划内配件起订金额
                      </th>
                      <td>
                        <el-input v-model="formData.snSiteInfoDTO.minPartsApplyAmount" :disabled="true" autocomplete="off" clearable
                                  type="number"  />
                      </td>

                      <th>
                        计划外配件起订金额
                      </th>
                      <td>
                        <el-input v-model="formData.snSiteInfoDTO.minPartsApplyAmountTwo" :disabled="true" autocomplete="off" clearable
                                  type="number" />
                      </td>

                      <th>
                        配件订单最大申请数
                      </th>
                      <td>
                        <el-input v-model="formData.snSiteInfoDTO.maxPartsApplyQty" :disabled="true" autocomplete="off" clearable
                                  type="number" />
                      </td>

                      <th>
                        每月加急配件数
                      </th>
                      <td>
                        <el-input v-model="formData.snSiteInfoDTO.limitUrgerPartsQty" :disabled="true" autocomplete="off" clearable
                                  type="number" />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        是否自动派单
                      </th>
                      <td>
                        <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                          <el-select v-model="formData.snSiteInfoDTO.isAutoIssue">
                            <el-option label="否" :value="0" />
                            <el-option label="是" :value="1" />
                          </el-select>
                        </el-form-item>
                      </td>
                      <th>
                        是否自动接单
                      </th>
                      <td>
                        <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                          <el-select v-model="formData.snSiteInfoDTO.siteAutoAccept">
                            <el-option label="否" :value="0" />
                            <el-option label="是" :value="1" />
                          </el-select>
                        </el-form-item>
                      </td>
                      <th>
                        是否预约超时考核
                      </th>
                      <td>
                        <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                          <el-select v-model="formData.snSiteInfoDTO.checkBeyondBookdate">
                            <el-option label="否" :value="0" />
                            <el-option label="是" :value="1" />
                          </el-select>
                        </el-form-item>
                      </td>
                      <th>
                        是否自动确认完工
                      </th>
                      <td>
                        <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                          <el-select v-model="formData.snSiteInfoDTO.autoComfirmOrder">
                            <el-option label="否" :value="0" />
                            <el-option label="是" :value="1" />
                          </el-select>
                        </el-form-item>
                      </td>
                    </tr>

                    <tr>
                      <th>
                        配件起订金额
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.minPartsApplyAmount" clearable />
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
              <div class="d-item">
              <div class="title first">
                <!-- <b>// 考核科目</b> -->
<!--                <el-button type="primary" class="button-sty btn_zdy" @click="showDialog = true; areaObj = null">-->
<!--                  <i class="el-icon-plus"></i>-->
<!--                  新增-->
<!--                </el-button>-->
<!--                <el-button type="primary" class="button-sty btn_zdy"  style="margin-left: 10px;">-->
<!--                  <i class="el-icon-delete"></i>-->
<!--                  删除-->
<!--                </el-button>-->
              </div>
              <vxe-table :stripe="true"
                :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                :header-row-style="{ height: '36px' }"
                :row-style="{height: '30px', fontSize: '12px', background: '#fff' }" show-overflow keep-source
                ref="xTable" height="150" :row-config="{ height: 36 }" :column-config="{ resizable: true }"
                :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }" :data="formData.snSiteNocheckList"

                >
                <vxe-colgroup title="网点免考核科目">
                <vxe-column type="checkbox" width="35"/>
                <vxe-column field="custName" title="考核科目" width="150" />
                <vxe-column title="操作" width="50">
                  <template #default="{ row }">
                    <a href="javascript:void(0);" class="a-link" @click="editArea(row)">
                      <el-tooltip effect="dark" content="编辑" placement="top" popper-class="tooltip-skin">
                        <i class="el-icon-edit" />
                      </el-tooltip>
                    </a>
                  </template>
                </vxe-column>
</vxe-colgroup>

              </vxe-table>
            </div>
              <div class="d-item">
                <div class="title first"><b>认证信息</b></div>
                <table class="table-detail">
                  <tbody>

                    <tr>
                      <th>网点照片</th>
                      <td colspan="">
                        <div class="form_picture">
                          <div>
                            <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove1"
                              list-type="picture-card" :file-list="picList1"
                              :on-success="(res, file, fileList) => { handleSuccess1(res, file, fileList) }"
                              :on-change="(files, fileList) => { handleImageChange(fileList) }" :auto-upload="true"
                              :on-preview="handlePictureCardPreview" :headers="headers">
                              <i slot="default" class="el-icon-plus"></i>
                            </el-upload>
                          </div>
                        </div>
                        <!-- <baseUpload accept="image/png, image/jpeg" multi="true" :showSortInput="true"></baseUpload> -->
                      </td>
                      <th>资质照片</th>
                      <td>
                        <div>
                          <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove2"
                            list-type="picture-card" :file-list="picList2"
                            :on-success="(res, file, fileList) => { handleSuccess2(res, file, fileList) }"
                            :on-change="(files, fileList) => { handleImageChange(fileList) }" :auto-upload="true"
                            :on-preview="handlePictureCardPreview" :headers="headers">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload>
                        </div>
                      </td>

                      <th>门头照片</th>
                      <td>
                        <div>
                          <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove3"
                            list-type="picture-card" :file-list="picList3"
                            :on-success="(res, file, fileList) => { handleSuccess3(res, file, fileList) }"
                            :on-change="(files, fileList) => { handleImageChange(fileList) }" :auto-upload="true"
                            :on-preview="handlePictureCardPreview" :headers="headers">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload>
                        </div>
                      </td>


                    </tr>
                    <tr>
                      <th>营业执照正本</th>
                      <td>
                        <div>
                          <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove4"
                            list-type="picture-card" :file-list="picList4"
                            :on-success="(res, file, fileList) => { handleSuccess4(res, file, fileList) }"
                            :on-change="(files, fileList) => { handleImageChange(fileList) }" :auto-upload="true"
                            :on-preview="handlePictureCardPreview" :headers="headers">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload>
                        </div>
                      </td>
                      <th>营业执照副本</th>
                      <td>
                        <div>
                          <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove5"
                            list-type="picture-card" :file-list="picList5"
                            :on-success="(res, file, fileList) => { handleSuccess5(res, file, fileList) }"
                            :on-change="(files, fileList) => { handleImageChange(fileList) }" :auto-upload="true"
                            :on-preview="handlePictureCardPreview" :headers="headers">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload>
                        </div>
                      </td>
                      <th>法人身份证正面</th>
                      <td>
                        <div>
                          <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove6"
                            list-type="picture-card" :file-list="picList6"
                            :on-success="(res, file, fileList) => { handleSuccess6(res, file, fileList) }"
                            :on-change="(files, fileList) => { handleImageChange(fileList) }" :auto-upload="true"
                            :on-preview="handlePictureCardPreview" :headers="headers">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload>
                        </div>
                      </td>
                      <th>法人身份证反面</th>
                      <td>
                        <div>
                          <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove7"
                            list-type="picture-card" :file-list="picList7"
                            :on-success="(res, file, fileList) => { handleSuccess7(res, file, fileList) }"
                            :on-change="(files, fileList) => { handleImageChange(fileList) }" :auto-upload="true"
                            :on-preview="handlePictureCardPreview" :headers="headers">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
<!--              <div class="d-item" style="position: relative;">-->
<!--                <div class="title first" style="width:30%"><b>合同信息</b></div>-->
<!--                <div style="margin: -30px 0px 0px 51vw;;">-->
<!--                      <el-button @click="addItem" type="primary" class="button-sty btn_zdy" style="margin-right: 5px;">-->
<!--                        增加-->
<!--                      </el-button>-->
<!--                      <el-button @click="deleteItem(item, index)" type="danger" class="button-sty btn_zdy">删除-->
<!--                      </el-button>-->
<!--                    </div>-->

<!--                    <el-form ref="form" :rules="formRules" :inline="true" :model="form" label-width="8vw">-->
<!--        <div v-for="(item, index) in form.dynamicItem" :key="index"  style="border:1px solid #ededed;    margin: 5px;padding-top: 5px;">-->
<!--          <el-form-item-->
<!--            label="合同名称"-->
<!--            :prop="'dynamicItem.' + index + '.contractName'"-->
<!--            :rules="{-->
<!--            required: true, message: '合同名称不能为空', trigger: 'blur'-->
<!--        }"-->
<!--          >-->
<!--            <el-input v-model="item.contractName" style="width: 165px;"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="合同号"-->
<!--            :prop="'dynamicItem.' + index + '.contractNo'"-->
<!--            :rules="[-->
<!--             {required: true, message: '合同号不能为空', trigger: 'blur'},-->
<!--          ]"-->
<!--          >-->
<!--            <el-input v-model="item.contractNo" style="width: 165px;"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="合同年月"-->
<!--            :prop="'dynamicItem.' + index + '.contractYear'"-->
<!--            :rules="[-->
<!--             {required: true, message: '合同年月不能为空', trigger: 'blur'},-->
<!--          ]"-->
<!--          >-->
<!--          <el-date-picker v-model="item.contractYear" type="date" placeholder="选择日期" style="width: 165px;">-->
<!--                        </el-date-picker>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="合同状态"-->
<!--            :prop="'dynamicItem.' + index + '.contractStat'"-->
<!--          >-->
<!--          <el-select v-model="item.contractStat" style="width: 165px;">-->
<!--                          <el-option label="未生效" :value="0" />-->
<!--                          <el-option label="已生效" :value="5" />-->
<!--                          <el-option label="已过期" :value="9" />-->

<!--                        </el-select>-->
<!--          </el-form-item>-->
<!--          <div>-->
<!--          <el-form-item-->
<!--            label="合同开始时间"-->
<!--            :prop="'dynamicItem.' + index + '.contractBeginTime'"-->
<!--          >-->
<!--          <el-date-picker v-model="item.contractBeginTime" type="date" placeholder="选择日期" style="width: 165px;">-->
<!--                        </el-date-picker>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="合同结束时间"-->
<!--            :prop="'dynamicItem.' + index + '.contractEndTime'"-->
<!--          >-->
<!--          <el-date-picker v-model="item.contractEndTime" type="date" placeholder="选择日期" style="width: 165px;">-->
<!--                        </el-date-picker>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="合同签署时间"-->
<!--            :prop="'dynamicItem.' + index + '.contractSignTime'"-->
<!--          >-->
<!--          <el-date-picker v-model="item.contractSignTime" type="date" placeholder="选择日期" style="width: 165px;">-->
<!--                        </el-date-picker>-->
<!--          </el-form-item></div>-->
<!--          <div style="position: relative;">-->
<!--          <el-form-item-->
<!--            label="合同文件"-->
<!--            :prop="'dynamicItem.' + index + '.contractFile'"-->
<!--            :rules="[-->
<!--             {required: true, message: '合同号不能为空', trigger: 'blur'},-->
<!--          ]"-->
<!--          >-->
<!--          <el-input id="file" :disabled="true" v-model="item.contractFile" style="width: 165px;"-->
<!--                          autocomplete="off" clearable />-->
<!--                      <el-upload style="display:flex; position: absolute; top: -3px;left: 190px;" class="upload-demo" ref="upload" :action="api.uploadFileUrl"-->
<!--                        accept=".docx,.doc,.pdf" :on-change="(files, fileList) => { handleImageChange(fileList) }"-->
<!--                        :file-list="file" :auto-upload="true" :headers="headers" :on-remove="pdfHandleRemove"-->
<!--                        :on-preview="handlePictureCardPreview"-->
<!--                        :on-success="(res, file, fileList) => { pdfHandleSuccess(res, file, fileList) }">-->
<!--                        <el-button type="primary" class="button-sty btn_zdy2">-->
<!--                          <i class="el-icon-plus"></i>-->
<!--                          选取文件-->
<!--                        </el-button>-->
<!--                      </el-upload>-->
<!--          </el-form-item>-->
<!--        </div>-->
<!--          &lt;!&ndash; <el-form-item>-->
<!--            <el-button v-if="index+1 == form.dynamicItem.length" @click="addItem" type="primary">增加</el-button>-->
<!--            <el-button v-if="index !== 0" @click="deleteItem(item, index)" type="danger">删除</el-button>-->
<!--          </el-form-item> &ndash;&gt;-->
<!--        </div>-->
<!--      </el-form>-->



<!--                &lt;!&ndash; <table class="table-detail">-->
<!--                  <tbody>-->
<!--                    <tr>-->
<!--                      <th>-->
<!--                        合同名称-->
<!--                      </th>-->
<!--                      <td>-->
<!--                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.contractName"-->
<!--                          clearable />-->
<!--                      </td>-->
<!--                      <th>-->
<!--                        合同号-->
<!--                      </th>-->
<!--                      <td>-->
<!--                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.contractNo" clearable />-->
<!--                      </td>-->
<!--                      <th>-->
<!--                        合同年月-->
<!--                      </th>-->
<!--                      <td>-->
<!--                        <el-input type="text" autocomplete="off" v-model="formData.snSiteInfoDTO.contractYear"-->
<!--                          clearable />-->
<!--                      </td>-->
<!--                      <th>-->
<!--                        合同状态-->
<!--                      </th>-->
<!--                      <td>-->
<!--                        <el-select v-model="formData.snSiteInfoDTO.contractStat">-->
<!--                          <el-option label="未生效" :value="0" />-->
<!--                          <el-option label="已生效" :value="5" />-->
<!--                          <el-option label="已过期" :value="9" />-->

<!--                        </el-select>-->
<!--                      </td>-->

<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <th>-->
<!--                        合同开始时间-->
<!--                      </th>-->
<!--                      <td>-->
<!--                        <el-date-picker v-model="formData.snSiteInfoDTO.contractBeginTime" type="date" placeholder="选择日期">-->
<!--                        </el-date-picker>-->
<!--                      </td>-->
<!--                      <th>-->
<!--                        合同结束时间-->
<!--                      </th>-->
<!--                      <td>-->
<!--                        <el-date-picker v-model="formData.snSiteInfoDTO.contractEndTime" type="date" placeholder="选择日期">-->
<!--                        </el-date-picker>-->
<!--                      </td>-->
<!--                      <th>-->
<!--                        合同签署时间-->
<!--                      </th>-->
<!--                      <td>-->
<!--                        <el-date-picker v-model="formData.snSiteInfoDTO.contractSignTime" type="date" placeholder="选择日期">-->
<!--                        </el-date-picker>-->
<!--                      </td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <th>-->
<!--                        合同文件-->
<!--                      </th>-->
<!--                      <td>-->
<!--                        <el-input id="file" :disabled="true" v-model="formData.snSiteInfoDTO.contractFile"-->
<!--                          autocomplete="off" clearable />-->
<!--                      </td>-->

<!--                      <el-upload style="display:flex" class="upload-demo" ref="upload" :action="api.uploadFileUrl"-->
<!--                        accept=".docx,.doc,.pdf" :on-change="(files, fileList) => { handleImageChange(fileList) }"-->
<!--                        :file-list="file" :auto-upload="true" :headers="headers" :on-remove="pdfHandleRemove"-->
<!--                        :on-preview="handlePictureCardPreview"-->
<!--                        :on-success="(res, file, fileList) => { pdfHandleSuccess(res, file, fileList) }">-->
<!--                        <el-button type="primary" class="button-sty btn_zdy2">-->
<!--                          <i class="el-icon-plus"></i>-->
<!--                          选取文件-->
<!--                        </el-button>-->
<!--                      </el-upload>-->

<!--                    </tr>-->
<!--                  </tbody>-->
<!--                </table> &ndash;&gt;-->

<!--              </div><div style="height: 50px;"></div>-->
            </div>
          </el-tab-pane>
          <el-tab-pane label="合同信息" name="second2">
<!--            <div class="d-cont edit-mce-box">-->
<!--              <div class="d-item" style="position: relative;">-->
<!--                <div class="title first" style="width:30%"><b>E签宝认证</b></div>-->
<!--                <div>-->
<!--                  <el-button @click="">认证</el-button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
            <div class="d-cont edit-mce-box">
              <div class="d-item" style="position: relative;">
                <div class="title first" style="width:30%"><b>合同信息</b></div>
                <div style="margin: -30px 0px 0px 51vw;;">
<!--                  <el-button @click="addItem" type="primary" class="button-sty btn_zdy" style="margin-right: 5px;">-->
<!--                    增加-->
<!--                  </el-button>-->
<!--                  <el-button @click="deleteItem(item, index)" type="danger" class="button-sty btn_zdy">删除-->
<!--                  </el-button>-->
                </div>
                <el-form ref="form" :inline="true" :model="form" label-width="8vw">
                  <contract-item v-for="(item, index) in form.dynamicItem" :key="index" :item.sync="item" :siteId="formData.id"/>
                </el-form>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="服务品类" name="third">
            <!-- 服务品类 -->
            <div class="d-cont edit-mce-box">

              <div class="d-item">
                <vxe-table :stripe="true"
                  :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '50%' }"
                  :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                  style="width:50%;" show-overflow row-id="id" :data="formData.itemCategoryList"
                  :tree-config="{ transform: true }"
                  :checkbox-config="{ labelField: 'name', checkRowKeys: formData.selectedItemCategoryIdList }"
                  @checkbox-change="itemCategorySelectChangeEvent" @checkbox-all="itemCategorySelectChangeEvent">
                  <vxe-column type="checkbox" width="80" tree-node></vxe-column>
                  <vxe-column field="categoryName" title="服务类型"></vxe-column>
                </vxe-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="服务区域" name="fourth">
            <!-- 服务区域 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <el-form-item>
                  <template>
                    <el-cascader :props="areaProps1" :clearable="true" @change="handleChange1" ref="cascaderAddr">
                    </el-cascader>
                    <el-button type="primary" class="button-sty btn_zdy" @click="addAreaData">
                      <i class="el-icon-plus"></i>
                      添加服务区域
                    </el-button>
                    <el-button style="margin: 5px 0;" type="primary" class="button-sty btn_zdy" @click="handleDeleteList">
                      <i class="el-icon-delete"></i>
                      批量删除
                    </el-button>
                  </template>
                </el-form-item>


                <vxe-table ref="filterTable" height="250" class="table_item pic_item" :column-config="{ resizable: true }"
                  style="width: 56%;" :stripe="true"
                  :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                  :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                  show-overflow :data="formData.snSiteAreaList" @checkbox-all="areaSelectAll"
                  @checkbox-change="areaSelect">
                  <vxe-column type="checkbox" width="55">
                  </vxe-column>

                  <vxe-column field="areaNamePath" title="省市区地址" width="`100%-115`">
                  </vxe-column>

                  <vxe-column title="操作" width="60">
                    <template #default="{ row }">
                      <div @click="handleDelete(row.id)">
                        <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                          popper-class="tooltip-skin">
                          <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                        </el-tooltip>
                      </div>
                    </template>
                  </vxe-column>
                </vxe-table>
                <!--                <el-button type="primary" class="button-sty btn_zdy" @click="showAreaDialog=true">-->
                <!--                  <i class="el-icon-plus"></i>-->
                <!--                  新增-->
                <!--                </el-button>-->
                <!--                <el-table ref="filterTable" border height="350" :data="table_area" class="table_item pic_item"-->
                <!--                          style="width: 95%;"-->
                <!--                          :header-cell-style="{ background: '#F6FAFF',padding: '0',borderTop: '1px solid #eaeaea',fontSize:'12px',color:'#808080'}"-->
                <!--                          :header-row-style="{height:'36px'}"-->
                <!--                          :row-style="{height:'30px',fontSize:'12px', background: '#fff'}">-->
                <!--                  <vxe-column type="selection" width="55">-->
                <!--                  </vxe-column>-->
                <!--                  <vxe-column prop="areaLevel" label="地区" width="600"/>-->

                <!--                  <vxe-column label="操作">-->
                <!--                    <template slot-scope="scope">-->
                <!--                      <div @click="handleDelete2(scope.$index)">-->
                <!--                        <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"-->
                <!--                                    popper-class="tooltip-skin">-->
                <!--                          <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>-->
                <!--                        </el-tooltip>-->
                <!--                      </div>-->
                <!--                    </template>-->
                <!--                  </vxe-column>-->
                <!--                </el-table>-->
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="服务类型" name="five">
            <!-- 服务类型 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <vxe-table :stripe="true"
                  :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '50%' }"
                  :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                  style="width:50%;" show-overflow resizable row-id="id" :data="formData.serviceTypeList"
                  :tree-config="{ transform: true }"
                  :checkbox-config="{ labelField: 'name', checkRowKeys: formData.selectedServiceTypeIdList }"
                  @checkbox-change="serviceTypeSelectChangeEvent" @checkbox-all="serviceTypeSelectChangeEvent">
                  <vxe-column type="checkbox" width="80" tree-node></vxe-column>
                  <vxe-column field="serviceTypeName" title="服务类型"></vxe-column>
                </vxe-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="服务渠道" name="six">
            <!-- 服务区域 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div>
                  <vxe-table :stripe="true"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }"
                             :row-style="{ fontSize: '12px', }"  style="width:50%;"
                             :checkbox-config="{ labelField: 'name', checkRowKeys: formData.selectedBuyChannelIdList }"
                             @checkbox-change="buyChannelChangeEvent"
                             @checkbox-all="buyChannelChangeEvent" show-overflow resizable
                             :column-config="{ resizable: true }"
                             :data="formData.buyChannelList"
                             :tree-config="{transform: true}"
                             row-id="id"
                  >

                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="buyChannelName" title="购买渠道"></vxe-column>
                  </vxe-table>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label=" 修改记录" name="seven">
            修改记录
          </el-tab-pane>
        </el-tabs>
      </div>

    </el-form>

    <el-image-viewer v-if="dialogVisible" :on-close="closeImgViewer" :url-list="dialogImageUrlList" />
    <!--    <el-dialog :visible.sync="dialogVisible">-->
    <!--      <img width="100%" :src="dialogImageUrl" alt="">-->
    <!--    </el-dialog>-->

    <site-dialog v-if="showSiteDialog" @commit="commitSelectedRow" :visiable.sync="showSiteDialog" multi="true"
      :excludeId="dataId" :siteFloorLevel="1" />
    <site-dialog v-if="showProxySiteDialog" @commit="commitSelectedRow1" :visiable.sync="showProxySiteDialog" multi="true"
      :excludeId="dataId" />
    <preconditionDialog2 v-if="showPreconditionDialog" @confirm="commitSelectedRow"
      :visiable.sync="showPreconditionDialog" :symptomId="symptomId" multi="true" />
    <areaDialog v-if="showAreaDialog" @commitData="commitAreaData" :areaObj="areaObj" :visiable.sync="showAreaDialog"
      multi="true" />
<!-- /考核科目 -->
<checkSubjectDialog v-if="showDialog" :param="param" :visiable.sync="showDialog" @commitSelect="commitSelect"/>


  </div>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
import preconditionDialog from './dialog';
import areaDialog from './areadialog.vue';
import store from "@/store";
import {editPageMixins,siteMixins} from "@/mixins/tabChang";

import api from "@/api/projectApi";
import { echoFileFormat, uploadFileFormat } from "@/util/uploadFormat";
import { dictType, loadDictData } from "@/config/dictType";
import siteDialog from "@/views/dialogCommon/radioSiteDialog.vue"
// 添加明细
import preconditionDialog2 from '@/views/dialogCommon/partsInvDialog.vue';
// 考核科目
import checkSubjectDialog from "@/views/dialogCommon/duoCheckSubjectDialog.vue";
import {mapGetters} from "vuex";
import ContractItem from "@/views/dialogCommon/contractItem.vue";
export default {
  mixins: [editPageMixins,siteMixins],

  inject: ['reload'],
  name: 'edit',
  props: {
    // _dataId: [String, Number],
    showSave: [Boolean]
  },
  components: {
    ContractItem,
    Tinymce,
    areaDialog,
    preconditionDialog,
    preconditionDialog2,
    checkSubjectDialog,
    siteDialog,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      showAddressListTable: true,
      // 考核科目
      snUserSave : false,
      showDialog: false,

      formRules: {},

      form: {
        dynamicItem: [
          {
            siteId: '',  // 网点ID,关联sn_user.i;
            contractName : '', //合同名称
            contractNo : '', //合同号
            contractYear : '', //合同年月
            contractFile : '1', //合同文件
            contractBeginTime : '', //合同开始时间
            contractEndTime : '', //合同结束时间
            contractStat : '', //合同状态:0未生效;5已生效;9已过期
            contractSignTime : '', //合同签署时间
          }
        ]
      },

      selectedData: [],

      siteType: '',  // 性质：1个人服务商；2特约服务商;3经销商;4配件代理商
      siteTypeName : '', // 性质名称,冗余字段

      formData: {
        basCustAddressList: [],
        id : '',
        createBy: '',
        createTime: '',
        userType: 2,  // 用户类型:2网点
        userAccount: null,  // 登陆帐号,可重复
        userName: '',  // 用户名称
        userShortName: '',  // 用户简称
        userMobile: '',  // 联系方式,可重复
        userProvince: null,  // 省
        userCity: null,  // 市
        userCounty: null,  // 区
        userTown: null,  // 镇
        areaId: '',  // 地区ID,关联bas_area.id
        userAddress: '',  // 详细地址
        longitude: '',  // 地址经度
        latitude: '',  // 地址纬度
        userPhoto: '',  // 用户图片
        stat: 1,  // 状态:1待审核;2审核中;3审核驳回;5已审核;91暂停、92暂挂、98撤消、99黑名单;小于5的状态都可以登陆

        snSiteInfoDTO: {
          siteId: '',  // 网点ID,关联sn_user.id;

          siteType: '',  // 性质：1个人服务商；2特约服务商;3经销商;4配件代理商
          siteTypeName : '', // 性质名称,冗余字段
          businessStat : '', // 运营状态:1提报、2备用、3正常、4清账、5终止、9黑名单
          starLevel : '' , // 星级：1一级，2二级，3三级，4四级，5五级
          siteCode: '',  // 编码
          orgId: '',  // 所属中心，关联脚手架机构表sys_dept.dept_id
          orgName: '',  // 所属机构名称,冗余字段
          orgIdPath: '',  // 所属机构ID路径,冗余字段.重要
          siteLevelId: '',  // 等级ID，关联脚手架数据字典项目表sys_dict_item.id
          siteLevelName: '',  // 等级名称,冗余字段
          siteFloorLevel: 1,  // 层级:1、一级网点；2、二级网点；
          parentSiteId: '',  // 上级网点ID,关联sn_user.id;网点层级为2时必有值
          settleSiteId: '',  // 代理结算网点ID,关联sn_user.id

          siteTaxNo: '',  // 税号
          siteInvoiceType: 0,  // 网点：发票类型（0无发票；1、增值税普通发票；2、增值税专用发票）
          siteInvoiceRate: 0,  // 网点：税率
          bankName: '',  // 银行名称
          bankAccount: '',  // 银行帐号
          bankAccountName: '',  // 银行帐户
          legalPersonCompany : '', // 法人单位
          legalPerson : '', // 法人代表
          legalPersonMobile : '', // 法人联系方式

          isAutoIssue: 0,  // 是否自动派单：0否1是
          siteAutoAccept: 0,  // 是否自动接单：0否1是
          siteMessagePhone1: '',  // 网点：接收短信手机1
          siteMessagePhone2: '',  // 网点：接收短信手机2
          siteOverAllArea: 0,  // 是否全国性网点:0否1是
          siteDistanceBasAddress: '',  // 远程费计算起点
          siteDisBas: null,  // 远程费基数。千万不要默认为0，要为null
          siteDisRate: null,  // 远程费费率。千万不要默认为0，要为null
          siteTopDis: null,  // 封顶远程费。千万不要默认为0，要为null
          thirdRequestAppsecret: '',  // 第三方接口appsecret(随机生成，长度32位)
          checkBeyondBookdate: 0,  // 是否预约超时考核:0否1是
          autoComfirmOrder: 0,  // 是否自动确认完工：0否1是
          minPartsApplyAmount: 0,//配件起订金额
          limitPartsBalance: 0, // 限冲帐金额

          siteCompanyName: '',  // 网点公司名称
          abilityPhoto: '',  // 资质照片
          shopPhoto: '',  // 门头照片
          legalPersonPhoto : '', // 法人身份证正面
          legalPersonPhoto2 : '', // 法人身份证反面
          businessPhoto: '',  // 营业执照正本照片
          businessPhoto2: '',  // 营业执照副本照片

          contractFile: '',  // 合同文件
          contractBeginTime: '',  // 合同开始时间
          contractEndTime: '',  // 合同结束时间

          siteMan: '',  // 联系人
          siteManMobile : '', //联系人电话
          siteManPid: '',  // 联系人身份证号
          siteOrderMan: '',  // 信息员或联系方式
          siteFinMan: '',  // 财务员或联系方式
          sitePartsMan: '',  // 配件员或联系方式
          siteEngineerMan: '',  // 工程师负责人或联系方式
          siteTechMan: '',  // 技术负责人或联系方式
          siteDescription: '',  // 网点介绍

          parentSiteName: '',  // 上级网点
          settleSiteName: '',  // 代理结算网点
        },
        SnSiteContractDTO : { //合同表
          siteId: '',  // 网点ID,关联sn_user.id;
          contractName : '', //合同名称
          contractNo : '', //合同号
          contractYear : '', //合同年月
          contractFile : '', //合同文件
          contractBeginTime : '', //合同开始时间
          contractEndTime : '', //合同结束时间
          contractStat : '', //合同状态:0未生效;5已生效;9已过期
          contractSignTime : '', //合同签署时间
        },
        snSiteContractDTOS : [],//合同集合表
        snSiteAddressDTOS : [], //地址信息表

        snSiteAreaList: [], // 服务区域

        serviceTypeList: [],
        selectedServiceTypeIdList: [], //服务类型
        itemCategoryList: [],
        selectedItemCategoryIdList: [], //网点服务品类
        buyChannelList : [],
        selectedBuyChannelIdList : [] //服务渠道
      },

      areaOption: [],
      areaValues: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      picList1: [],
      picList2: [],
      picList3: [],
      picList4: [],
      picList5: [],
      picList6: [],
      picList7: [],
      file: [],
      siteLevelOption: [],
      siteTypeOption : [], //网点性质下拉框
      showSiteDialog: false,
      showProxySiteDialog: false,

      areaProps1: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad1
      },
      area: {
        temp: {},
        checkedArray: []
      },
      areaData: [],

      orgOptions: [],
      orgValue: '',


      showPreconditionDialog: false,
      showAreaDialog: false,
      areaObj: null,

      isIndeterminate: [true, false],
      isIndeterminate2: true,
      // 以上卡片数据
      //  第四个页面表---服务类型


      activeName: 'first',
      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: null,

      showProductCategoryDialog: false,
      languageDTOs: [],
      dialogImageUrl: '',
      dialogImageUrlList: [],
      dialogVisible: false,
      uploadDisabled: false,


    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }
  },
  watch: {
    picList1: {
      handler(newVal, oldVal) {
        this.formData.userPhoto = uploadFileFormat(newVal)
        console.log(this.formData)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList2: {
      handler(newVal, oldVal) {
        this.formData.snSiteInfoDTO.abilityPhoto = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList3: {
      handler(newVal, oldVal) {
        this.formData.snSiteInfoDTO.shopPhoto = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList4: {
      handler(newVal, oldVal) {
        this.formData.snSiteInfoDTO.businessPhoto = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList5: {
      handler(newVal, oldVal) {
        this.formData.snSiteInfoDTO.businessPhoto2 = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList6: {
      handler(newVal, oldVal) {
        this.formData.snSiteInfoDTO.legalPersonPhoto = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList7: {
      handler(newVal, oldVal) {
        this.formData.snSiteInfoDTO.legalPersonPhoto2 = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    file: {
      handler(newVal, oldVal) {
        this.formData.snSiteInfoDTO.contractFile = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
  },
  created() {
    this.snUserSave = this.permissions['snUserSave']
     // 是否是服务商角色
     console.log(this.currentIsSite,this.dataId2,"this.currentIsSite的值");
    const userInfo = store.getters.userInfo;
    this.dataId =this.dataId2
    // this.formData.userName=this.userName2
    console.log(userInfo,this.dataId,'用户信息5555555554');
    if (userInfo.siteDto && userInfo.siteDto.siteId){
      this.isSite = true;
    }
  },
  mounted() {
    this.loadDictData()
    this.loadOrgData()
    this.loadSiteTypeData()
    this.getData();
    // console.log(this.tenant, "tenant的值");
    console.log(this.dataId, "dataId的值");
  },
  methods: {
    // 方法名称固定，用于当前用户为网点用户时自动设置网点数据
    setSiteData() {
      let siteData = this.currentSiteData;
    },
    commitSelect(row) {
      console.log(row, 'commitSelect 考核科目')
      // this.checkSubjectName = row.name
      // this.checkSubjectId = row.id
      // this.$emit('update:checkSubjectName', this.checkSubjectName)
      // this.$emit('update:checkSubjectId', this.checkSubjectId)
    },
    //获取网点性质名称
    selectSiteType(data){
      this.formData.snSiteInfoDTO.siteType = data.value;
      this.formData.snSiteInfoDTO.siteTypeName = data.label;
    },

    addItem() {
      this.form.dynamicItem.push({
        changeId: '',  // 变更单ID,关联sn_user_change.id;
        contractName : '', //合同名称
        contractNo : '', //合同号
        contractYear : '', //合同年月
        contractFile : '1', //合同文件
        contractBeginTime : '', //合同开始时间
        contractEndTime : '', //合同结束时间
        contractStat : '', //合同状态:0未生效;5已生效;9已过期
        contractSignTime : '', //合同签署时间
      });
    },
    sure(form) {
      console.log(this.form.dynamicItem.length, "length");
      this.$refs[form].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deleteItem(item, index) {
      this.form.dynamicItem.splice(index, 1);
      console.log(this.form.dynamicItem, "删除");
    },

    insertEvent (opts) {
              const $table = this.$refs.xTable
              $table.readFile(opts).then(params => {
                const { files } = params
                const records = Array.from(files).map(file => {
                  const ns = file.name.split('.')
                  const name = ns.slice(0, ns.length - 1).join('')
                  const type = ns[ns.length - 1]
                  return {
                    name: name,
                    size: file.size,
                    type: type,

                  }
                })
                $table.insert(records)
              })
            },

    editArea(row) {
      this.areaObj = row
      this.showAreaDialog = true
    },

    commitAreaData(data) {
      let filter = this.formData.basCustAddressList.filter(item => item.id != data.id)
      if (data.isDefault == 1) {
        filter.forEach(item => {
          item.isDefault = 0
        })
      }
      filter.push(data)

      this.formData.basCustAddressList = filter
      this.updateAddressList()
    },

    // 删除地址
    deleteArea(data) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.showAddressListTable = false
        console.log('asdfkasd', data, this.formData.basCustAddressList)
        let temp = this.formData.basCustAddressList
        temp = temp.filter(item => item.id != data.id)
        this.formData.basCustAddressList = temp
        this.showAddressListTable = true
        this.updateAddressList()
      })
    },

    // 服务商异步生成地址
    updateAddressList() {
      if (this.currentIsSite) {
        this.$mask.open()
        this.$http.post(api.snUser.updateAddressListUrl, {id: this.formData.id, snSiteAddressDTOS: this.formData.basCustAddressList}).then(() => {
          this.$message.success('保存成功')
          this.$mask.close()
        })
      }
    },

    commitData(data) {
      console.log(data, 'commitData')
      let temp = this.formData.basCustAsseList.filter(item => item.id != data.id)
      temp.push(data)
      this.formData.basCustAsseList = temp
      // if (isRefresh) {
      //   this.getTableData()
      // } else {
      //   if (this.formData.basCustAsseList.length !== 0) {
      //     this.formData.basCustAsseList = this.formData.basCustAsseList.filter(item => item.id !== data.id)
      //   }
      //   this.formData.basCustAsseList.push(data)
      // }
      // console.log(this.formData.basCustAsseList, '---------')
    },
    deleteData() {
      // this.$refs.editForm.validate(valid => {
      //   if (valid) {
      let temp = this.formData.tableData1
      this.selectedData.forEach(item => {
        temp = temp.filter(item1 => item1.id != item.id)
      })
      this.formData.tableData1 = temp
      //   }
      // })
    },
    selectChangeEvent(data) {
      console.log('sakdjfksd', data)
      this.selectedData = data.records
    },
    closeImgViewer() {
      this.dialogVisible = false
    },

    inspection() {
      if (this.formData.userAccount) {
        this.$http({
          url: api.snUser.inspectionUrl,
          method: 'post',
          data: {
            value: this.formData.userAccount,
            id: this.formData.id,
          }
        }).then(res => {
          if (!res.data.data) {
            this.$message.warning("登录账号已存在，请重新输入")
            this.formData.userAccount = null
          }
        })
      }
    },

    // 服务品类复选框
    itemCategorySelectChangeEvent({ records }) {
      // 拿到所有id
      let temp = records.map(item => item.id)

      // 获取有子类的父id
      let parentTemp = new Set()
      records.forEach(item => {
        if (item.parentId != 0) {
          parentTemp.add(item.parentId)
        }
      })

      // 去除有子类的父id
      let temp1 = []
      temp.forEach(item => {
        if (!parentTemp.has(item)) {
          temp1.push(item)
        }
      })
      this.formData.selectedItemCategoryIdList = temp1
      console.log('选中的服务类型id', temp1)
    },

    // 服务类型复选框
    serviceTypeSelectChangeEvent({ records }) {
      // 拿到所有id
      let temp = records.map(item => item.id)

      // 获取有子类的父id
      let parentTemp = new Set()
      records.forEach(item => {
        if (item.parentId != 0) {
          parentTemp.add(item.parentId)
        }
      })

      // 去除有子类的父id
      let temp1 = []
      temp.forEach(item => {
        if (!parentTemp.has(item)) {
          temp1.push(item)
        }
      })
      this.formData.selectedServiceTypeIdList = temp1
      console.log('选中的服务类型id', temp1)
    },

    buyChannelChangeEvent({records}) {
      this.formData.selectedBuyChannelIdList = records.map(item => item.id)
      console.log('购买渠道选中', this.formData.selectedBuyChannelIdList)
    },

    commitSelectedRow(data) {
      this.formData.snSiteInfoDTO.parentSiteId = data.id
      this.formData.snSiteInfoDTO.parentSiteName = data.name
    },
    commitSelectedRow1(data) {
      this.formData.snSiteInfoDTO.settleSiteId = data.id
      this.formData.snSiteInfoDTO.settleSiteName = data.name
    },

    // 网点等级改变
    levelChange() {
      if (this.formData.snSiteInfoDTO.siteLevelId !== '') {
        this.siteLevelOption.forEach(item => {
          if (item.id === this.formData.snSiteInfoDTO.siteLevelId) {
            this.formData.snSiteInfoDTO.siteLevelName = item.label
          }
        })
      }
    },

    // 加载机构数据
    loadOrgData() {
      this.$http({
        url: api.sysDept.getDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        console.log(res.data.data)
        this.orgOptions = []
        res.data.data.forEach(item => {
          let temp = {
            value: item.id,
            label: item.name,
          }
          if (item.hasChild) {
            temp.children = []
            item.child.forEach(item1 => {
              temp.children.push({
                value: item1.deptId,
                label: item1.name
              })
            })
          }

          this.orgOptions.push(temp)
        })
      })
    },

    orgHandleChange(data) {
      if (data.length !== 0) {
        this.$http({
          url: '/admin/dept/' + data[data.length - 1],
          method: 'get'
        }).then(res => {
          console.log('选中机构', res.data.data)
          this.formData.snSiteInfoDTO.orgId = res.data.data.deptId
          this.formData.snSiteInfoDTO.orgName = res.data.data.name
          this.formData.snSiteInfoDTO.orgIdPath = res.data.data.orgIdPath
        })

      }

    },


    // 添加地区列表
    addAreaData() {
      if (this.area.temp.level < 3) {
        this.$message.warning('请至少选择到市级地址')
      } else {
        if (this.area.temp.level === 3 || this.area.temp.level === 4) {
          this.$http({
            url: api.basArea.getAreaPathDataUrl,
            method: 'post',
            data: {
              parentId: this.area.temp.id
            }
          }).then(res => {
            let tempArray = this.formData.snSiteAreaList
            if (tempArray == null) {
              tempArray = []
            }
            res.data.data.forEach(item => {
              tempArray.push({
                id: item.id,
                areaNamePath: item.areaNamePath
              })
            })
            this.formData.snSiteAreaList = this.uniqueArr(tempArray)
          })
        } else if (this.area.temp.level === 5) {
          this.$http({
            url: api.basArea.getAreaPathDataUrl,
            method: 'post',
            data: {
              areaId: this.area.temp.id,
            }
          }).then(res => {
            let tempArray = this.formData.snSiteAreaList
            res.data.data.forEach(item => {
              tempArray.push({
                id: item.id,
                areaNamePath: item.areaNamePath
              })
            })
            this.formData.snSiteAreaList = this.uniqueArr(tempArray)
          })
        }
      }
    },

    // 去重
    uniqueArr(arr) {
      let result = [];
      arr.forEach((item) => {
        if (!result.some(m => m.id === item.id)) {
          result.push(item);
        }
      });
      return result;
    },

    // 单个地区删除
    handleDelete(id) {
      console.log(id)
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.formData.snSiteAreaList = this.formData.snSiteAreaList.filter(item => item.id !== id)
      })
    },

    // 批量删除地区
    handleDeleteList() {
      console.log(typeof this.area.checkedArray)
      console.log(this.area.checkedArray.length)
      console.log(this.area.checkedArray)
      if (this.area.checkedArray.length === 0) {
        this.$message.warning('请先勾选地址')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.area.checkedArray.forEach(item => {
            this.formData.snSiteAreaList = this.formData.snSiteAreaList.filter(item1 => item1.id !== item.id)
          })
          this.area.checkedArray = []
        })
      }
    },

    // 单个地址选中
    areaSelect(data) {
      console.log(data, '选中')
      if (data.checked) {
        this.area.checkedArray.push(data.row)
      } else {
        this.area.checkedArray = this.area.checkedArray.filter(item => item.id !== data.row.id)
      }
      console.log('askdfksd', this.area.checkedArray)
    },

    // 地址全选
    areaSelectAll(selection) {
      console.log(selection)
      this.area.checkedArray = []
      let records = selection.records
      records.forEach(item => {
        this.area.checkedArray.push(item)
      })
      console.log(this.area.checkedArray.length)
    },

    // 地址三级联动
    handleChange1() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      this.area.temp = {
        id: areaNode[0].value,
        level: areaNode[0].level
      }
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },

    cascaderLazyLoad1(node, resolve) {
      if (!node) {
        return false
      }
      request({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.data || {};

        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },


    // 加载数据字典中网点等级
    loadDictData() {
      loadDictData(dictType.branchLevel).then(res => {
        this.siteLevelOption = []
        res.data.data.forEach(item => {
          this.siteLevelOption.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },

    // 加载数据字典中网点性质
    loadSiteTypeData() {
      loadDictData(dictType.siteQuality).then(res => {
        this.siteTypeOption = []
        res.data.data.forEach(item => {
          this.siteTypeOption.push({
            label: item.label,
            id: item.id
          })
        })
      })
    },

    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.formData.country = areaNode[0].label;
          this.formData.userProvince = null;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.userProvince = areaNode[0].label;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.userCity = areaNode[0].label;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 4) {
          this.formData.userCounty = areaNode[0].label;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.userTown = areaNode[0].label;
        }
        this.formData.areaId = areaNode[0].value
      } else {
        this.formData.areaId = null;
        this.formData.country = null;
        this.formData.userProvince = null;
        this.formData.userCity = null;
        this.formData.userCounty = null;
        this.formData.userTown = null;
      }

      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },

    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },
    // 地址数据回显
    echoAddress() {
      if (this.formData.areaId !== null && this.formData.areaId !== '') {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: { id: this.formData.areaId }
        }).then(res => {
          console.log(res)
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          this.area = res.data.data.names
        })
      }
    },


    saveData() {
      this.formData.snSiteContractDTOS = this.form.dynamicItem;
      this.formData.snSiteAddressDTOS = this.formData.basCustAddressList;
      console.log('保存数据', this.formData)
      let formData = this.formData;
      if (!formData.userProvince) {
        this.$message.warning('请选择地址')
        return
      }
      if (formData.selectedItemCategoryIdList.length === 0) {
        this.$message.warning('请选择服务品类')
        return
      }
      if (formData.snSiteAreaList.length === 0) {
        this.$message.warning('请选择服务区域')
        return
      }
      if (formData.selectedServiceTypeIdList.length === 0) {
        this.$message.warning('请选择服务类型')
        return
      }
      if (formData.selectedBuyChannelIdList.length === 0) {
        this.$message.warning('请选择服务渠道')
        return
      }
      // if (formData.snSiteAreaList.length === 0) {
      //   this.$message.warning('请选择服务区域')
      //   return
      // }
      this.$baseConfirm('您确定要保存吗？').then(() => {
        this.$http({
          url: this.isEdit ? api.snUser.updateDataUrl : api.snUser.addDataUrl,
          method: 'post',
          data: this.formData
        }).then(() => {
          this.$message.success("保存成功！")
          this.reload()
        }).catch(e => {
          console.error(e)
          this.$message.error("保存失败！")
        })
      })
    },


    handleCheckAllChange($event, val) {
      let temp = []
      if ($event) {  // 全选
        val.childList.forEach(item => {
          temp.push(item.id)
        })
      }
      val.checked = temp
      val.isIndeterminate = false
    },
    handleCheckedCitiesChange($event, val) {
      val.isIndeterminate = val.checked.length > 0 && val.childList.length > val.checked.length
      if (val.checked.length === val.childList.length) {
        val.checkAll = true
      } else {
        val.checkAll = false
      }
    },


    getData() {
      this.isEdit = true;
      this.$http({
        url: api.snUser.getDataUrl,
        method: 'post',
        data: {
          id: this.currentSiteData.id
        },
        isLoading: true,
        modalStrictly: true,
      }).then(res => {
        // console.log(res.data.data)
        this.formData = res.data.data
        console.log(this.formData,"this.formData请求的值");
        this.orgValue = this.formData.snSiteInfoDTO.orgId
        this.formData.basCustAddressList  = this.formData.snSiteAddressDTOS;
        this.form.dynamicItem  = this.formData.snSiteContractDTOS;
        // console.log(this.orgValue, 'orgValue')
        this.picList1 = echoFileFormat(this.formData.userPhoto)
        this.picList2 = echoFileFormat(this.formData.snSiteInfoDTO.abilityPhoto)
        this.picList3 = echoFileFormat(this.formData.snSiteInfoDTO.shopPhoto)
        this.picList4 = echoFileFormat(this.formData.snSiteInfoDTO.businessPhoto)
        this.picList5 = echoFileFormat(this.formData.snSiteInfoDTO.businessPhoto2)
        this.picList6 = echoFileFormat(this.formData.snSiteInfoDTO.legalPersonPhoto)
        this.picList7 = echoFileFormat(this.formData.snSiteInfoDTO.legalPersonPhoto2)
        this.file = echoFileFormat(this.formData.snSiteInfoDTO.contractFile)
        this.echoAddress()
      })
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleRemove1() {
      this.picList1 = []
    },
    handleSuccess1(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList1 = echoFileFormat(res.data.url)
    },
    handleRemove2() {
      this.picList2 = []
    },
    handleSuccess2(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList2 = echoFileFormat(res.data.url)
    },
    handleRemove3() {
      this.picList3 = []
    },
    handleSuccess3(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList3 = echoFileFormat(res.data.url)
    },
    handleRemove4() {
      this.picList4 = []
    },
    handleSuccess4(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList4 = echoFileFormat(res.data.url)
    },

    handleRemove5() {
      this.picList5 = []
    },
    handleSuccess5(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList5 = echoFileFormat(res.data.url)
    },

    handleRemove6() {
      this.picList6 = []
    },
    handleSuccess6(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList6 = echoFileFormat(res.data.url)
    },

    handleRemove7() {
      this.picList7 = []
    },
    handleSuccess7(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList7 = echoFileFormat(res.data.url)
    },

    pdfHandleRemove() {
      this.file = []
    },
    pdfHandleSuccess(res, file, fileList) {
      console.log(res.data.url, "url")
      this.file = echoFileFormat(res.data.url)
    },

    //
    // areaconfirm(rows) {
    //   if (rows.length > 0) {
    //
    //     const tableData = this.table_area;
    //     const map = {};
    //     tableData.forEach(function (item) {
    //       map[item.preconditionId] = 1;
    //     });
    //     var items = [];
    //     rows.forEach((row, index) => {
    //       const item = {
    //         preconditionId: row.id,
    //         areaName: row.precondition
    //       };
    //       if (!map[item.preconditionId]) {
    //         items.push(item);
    //       }
    //     });
    //     this.table_area = this.table_area.concat(items);
    //   }
    // },
    // preconditionconfirm(rows) {
    //   if (rows.length > 0) {
    //
    //     const tableData = this.table_type;
    //     const map = {};
    //     tableData.forEach(function (item) {
    //       map[item.preconditionId] = 1;
    //     });
    //     var items = [];
    //     rows.forEach((row, index) => {
    //       const item = {
    //         preconditionId: row.id,
    //         typeName: row.precondition
    //       };
    //       if (!map[item.preconditionId]) {
    //         items.push(item);
    //       }
    //     });
    //     this.table_type = this.table_type.concat(items);
    //   }
    // },

    // // 上传成功
    // handleSuccess(response, file) {
    //   // 上传成功后，隐藏上传按钮
    //   this.upload_btn = true;
    //   // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
    //   // Vue.set(this.tenant.shopPhoto, 'pic', res.data.url)
    //
    // },
    // handleRemove(response, file) {
    //   // 上传成功后，显示上传按钮
    //   this.upload_btn = false;
    // },

    // // 上传成功
    // handleSuccess4(res, file, picIndex) {
    //   // 上传成功后，隐藏上传按钮
    //   this.upload_btn4 = true;
    //   // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
    //   Vue.set(this.tenant.businessPhoto,)
    //
    // },
    // handleRemove4(response, file) {
    //   // 上传成功后，显示上传按钮
    //   this.upload_btn4 = false;
    // },
    // handleDelete2(index) {
    //   this.table_area.splice(index, 1);
    // },
    // handleDelete(index) {
    //   this.table_type.splice(index, 1);
    // },

    // 第一个  表格
    formatter(row, column) {
      return row.address;
    },
    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrlList = [file.url]
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 上传发生变化钩子
    // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
    // handleimageChange(file, fileList) {
    //   this.upload_img = fileList;
    //   // this.upload_img.imageName=fileList.name;
    //   console.log(fileList, "文件状态改变时")
    //   console.log(file, "文件状态改变时file")
    // },
  },
};

</script>
<style lang="scss" scoped>
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  >span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  >div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 80px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

// ::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
//   width: 80px;
//   height: 40px;
//   padding: 0 !important;
//   position: inherit;
//   cursor: pointer;
// }

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover>td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

#containt .detail-wrap .d-cont {
  overflow: auto !important;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

.heTong{
  border: 1px solid #ededed;
}
::v-deep  .detail-wrap .d-header {
    margin: 0px -12px 0 !important;
}
</style>
